module.exports = __webpack_public_path__ + "60d314b1c059149dd36a9a5d2a35b734.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/glasses-reading-s.png
// module id = 2343
// module chunks = 0